import React, { useEffect } from "react";

import DatatablePage from "../../../layout/datatable-pages/companies";
import { fetchData, getCompaniesFieldsArray } from "../../../utils/helpers";
import { props } from "../../datatable/props";
import useDatatable from "../../hooks/useDatatable";

import "../datatable-pages.css";
import { useSupabaseApp } from "../../../SupabaseApp";

/**
 * DataRoomPitchDecks Component
 * 
 * Displays a paginated datatable of pitch decks available in the data room repository.
 * Users can search through 38+ attributes related to companies and their pitch deck submissions.
 * A sticky column displays company slug for easy reference during vertical scrolling.
 * Includes comprehensive business information, financial metrics, and company relationships.
 * Data room serves as a secure repository for pitch deck documents. Requires authentication.
 * 
 * @returns {JSX.Element} Datatable page with data room pitch decks
 */
const DataRoomPitchDecks = () => {
  // Array of field keys for pitch decks datatable
  const fieldKeys = [
    "tradeName",
    "entityType",
    "isActive",
    "slug",
    "stageOfDevelopment",
    "description",
    "reasonsForFailure",
    "industry",
    "categories",
    "location",
    "ownership",
    "businessModelType",
    "defensibilityMoat",
    "productReview",
    "lastFinancingRound",
    "totalInvestment",
    "postMoneyValuation",
    "lastFinancingDate",
    "numOfFundingRounds",
    "numOfInvestors",
    "investors",
    "revenue",
    "market",
    "investments",
    "numOfAcquisitions",
    "boardSeats",
    "competitors",
    "similarEntities",
    "management",
    "numOfEmployees",
    "reputation",
    "phoneNumber",
    "operationalDuration",
    "shutdownDate",
    "foundedDate",
    "legalName",
    "former_legalName",
    "ticker",
  ];

  // Column that remains visible during horizontal scrolling
  const stickyField = "slug";

  // Convert field keys to formatted field objects with sticky column preference
  const fields = getCompaniesFieldsArray(fieldKeys, stickyField);

  // Get datatable state and props
  const { datatableProps } = useDatatable();

  // Get Supabase utilities and user context
  const { currentUser, supabase, getUserTier } = useSupabaseApp();

  // Verify user authentication
  if (!currentUser) {
    throw new Error(`Must be logged in`);
  }

  // Configuration for data room pitch decks datatable
  const params = {
    supabase,
    ...datatableProps,
    getData: "getDataRoomPitchDecks",
    collection: "companies",
    title: "Data room",
    datatipText: "",
    statsArray: [
      {
        actualName: "",
        displayName: "",
        total: "",
      },
    ],
    placeholderText: "Search from data room",
    fields: fields,
    getCompanyDetailsForExpand: "getCompanyDetailsForExpand",
  };

  // Fetch pitch deck data on component mount
  useEffect(() => {
    fetchData(params);

    // Set to get unique objects
    // let setObj = new Set(allfields.map(JSON.stringify));
    // let output = Array.from(setObj).map(JSON.parse); // Output
    // console.log(output);
  }, []);

  // Render datatable page with configured params
  return <DatatablePage props={props(params)} />;
};

export default DataRoomPitchDecks;
